import { createTheme } from '@mui/material/styles';

// Keep in sync with the CSS custom properties in App.scss.
export const tokens = {
  asphalt: '#E9ECEF',
  surface: '#FFFFFF',
  graphite: '#1C2127',
  steel: '#5B6670',
  line: '#D3D8DD',
  atnRed: '#B3121F',
};

export const TEAM_LIVERY = {
  red: { label: 'Red', color: '#D7263D' },
  blue: { label: 'Blue', color: '#1D5FD6' },
  green: { label: 'Green', color: '#15935B' },
  black: { label: 'Black', color: '#2A2F36' },
};

const condensed = '"Barlow Condensed", "Arial Narrow", sans-serif';
const body = '"Barlow", "Helvetica Neue", Arial, sans-serif';

const theme = createTheme({
  palette: {
    primary: { main: tokens.atnRed, contrastText: '#fff' },
    secondary: { main: tokens.graphite },
    error: { main: '#C62828' },
    success: { main: '#15935B' },
    background: { default: tokens.asphalt, paper: tokens.surface },
    text: { primary: tokens.graphite, secondary: tokens.steel },
    divider: tokens.line,
  },
  shape: { borderRadius: 6 },
  typography: {
    fontFamily: body,
    fontSize: 15,
    h1: { fontFamily: condensed, fontWeight: 800, fontSize: '2.75rem', lineHeight: 1.05 },
    h2: { fontFamily: condensed, fontWeight: 700, fontSize: '2rem', lineHeight: 1.1 },
    h3: { fontFamily: condensed, fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.15 },
    h4: { fontFamily: condensed, fontWeight: 600, fontSize: '1.25rem' },
    button: { fontFamily: body, fontWeight: 600, textTransform: 'none', letterSpacing: 0 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 6, paddingInline: 18 }, sizeLarge: { paddingBlock: 11 } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: `1px solid ${tokens.line}` } },
    },
    MuiTextField: { defaultProps: { fullWidth: true } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: tokens.surface } } },
    MuiTableCell: {
      styleOverrides: {
        head: { color: tokens.steel, fontWeight: 600, fontSize: '0.85rem' },
      },
    },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600, fontSize: '1rem' } } },
    MuiDialog: { styleOverrides: { paper: { border: 'none' } } },
    MuiMenu: { styleOverrides: { paper: { border: `1px solid ${tokens.line}` } } },
  },
});

export default theme;
